// extracted by mini-css-extract-plugin
module.exports = {"description":"Input_description___xYr_","descriptionLabel":"Input_descriptionLabel__JaWUH","descriptionTextarea":"Input_descriptionTextarea__9NkJx"};